export default "__VITE_ASSET__BcstBP7k__"